import { startOfMonth } from "date-fns";
import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";

import { sendDeliveryDateChange } from "../../common/tracking";
import type { DayFlagLabel } from "../../common/types/calendarTypes";
import useMediaQuery from "../../common/useMediaQuery";
import { mediaQueries } from "../../common/utils";
import availabilityStore from "../../stores/availabilityStore";
import cartStore from "../../stores/cart/cartStore";
import deliveryDatesStore from "../../stores/deliveryDates/deliveryDatesStore";
import CalendarKeys from "../common/calendar/CalendarKeys";
import DatePicker from "../common/datepicker/DatePicker";

type DeliveryDateButtonProps = {
   render: (dates: Date[], isPickerOpen: boolean, setPickerOpen: (show: boolean) => void) => ReactNode;
   size?: "compact" | "regular";
   inline?: boolean;
};

const DeliveryDateButton = ({ render, size = "compact", inline }: DeliveryDateButtonProps) => {
   const isDesktop = useMediaQuery(mediaQueries.sm);
   const labels: DayFlagLabel[] = [
      { flag: "selected", label: "Valgt leveringsdag" },
      { flag: "selectable", label: "Tilgjengelig for levering" },
      { flag: "cancelled", label: "Ikke tilgjengelig" }
   ];
   const handleChange = (dates: Date[]) => {
      const date = dates[0];
      if (date) {
         availabilityStore.clearAvailability();
         deliveryDatesStore.changeDeliveryDate(date);
         sendDeliveryDateChange();
      }
   };
   return (
      <DatePicker
         monthCount={isDesktop ? 2 : 1}
         min={startOfMonth(new Date())}
         render={render}
         size={size}
         dates={cartStore.deliveryDateForPicker()}
         onDatesChange={handleChange}
         getDayFlags={deliveryDatesStore.getDayFlags}
         closeOnChange={true}
         inline={inline}
         currentMonthOnly
      >
         <CalendarKeys flagLabels={labels} />
      </DatePicker>
   );
};

export default observer(DeliveryDateButton);
